export default "__VITE_ASSET__aab4430b__"